import React, { useEffect } from 'react';

import IFrameEmbed from 'craft/components/IFrameEmbed';
import Node from 'craft/components/Node';
import { stringWithFallbacks } from 'craft/containers/Actions/parseVariables';
import { useEditorNode, useNodeContext } from 'craft/hooks';
import { Resolver, ToolboxComponentSections } from 'craft/types';

import { IFrameToolbox } from './IFrameToolbox';

export const DEFAULT_WIDTH = 'auto';
export const DEFAULT_HEIGHT = '360px';

interface Props {
  src?: string;
  width: string;
  height: string;
}

export const IFrame: Resolver<Props> = ({ src, width, height }: Props) => {
  const { id } = useNodeContext();
  const { setProps } = useEditorNode(id);

  useEffect(() => {
    if (width && height) {
      return;
    }
    if (!width && !height) {
      setProps({ width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT });
    }
    if (!width) {
      setProps({ width: DEFAULT_WIDTH, height });
    }
    if (!height) {
      setProps({ width: width || DEFAULT_WIDTH, height: 'auto' });
    }
  }, [setProps, width, height]);

  return (
    <Node style={{ height, width }}>
      <IFrameEmbed src={stringWithFallbacks(src)} />
    </Node>
  );
};

IFrame.craft = {
  name: 'IFrame',
};

IFrame.resize = {
  shouldDisableHandlers: true,
};

IFrame.toolbox = {
  component: [IFrameToolbox],
  schema: {
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['flex', 'inline-block'],
    },
  },
};
